import Repository from './repository';

const resource = '/merchant';
export default {
	stats() {
		return Repository.getWithAuth(`${resource}/stats`);
	},
	allmerchantsstats(payload) {
		return Repository.postWithAuth(`${resource}/stats`, payload);
	},
	renameMerchant(payload) {
		return Repository.postWithAuth(
			`${resource}/update`,
			payload,
			{},
			{ noCache: true }
		);
	},
	statsbyid(id) {
		return Repository.getWithAuth(`${resource}/stats/${id}`);
	},
	getMerchantById(id) {
		return Repository.getWithAuth(`${resource}/${id}`);
	},
	getBillingConfig(id) {
		return Repository.getWithAuth(`${resource}/${id}/billing-config`);
	},
	getBranding(id) {
		return Repository.getWithAuth(`${resource}/branding/${id}`);
	},
	getCurrentBranding() {
		return Repository.getWithAuth(`${resource}/branding`);
	},
	getSystemBranding() {
		return Repository.getWithAuth(`${resource}/branding/system`);
	},
	updateBranding(id, payload) {
		return Repository.putWithAuthForm(`${resource}/branding/${id}`, payload);
	},
	removeBranding(id) {
		return Repository.deleteWithAuth(`${resource}/branding/${id}`);
	},
	find(payload) {
		return Repository.postWithAuth(`${resource}/find`, payload);
	},
	addwithaccountpermission(payload) {
		return Repository.postWithAuth(`${resource}/permissions`, payload);
	},
	delete(id) {
		return Repository.deleteWithAuth(`${resource}/${id}`);
	},
	block(payload) {
		return Repository.putWithAuth(`${resource}/block`, payload);
	},
	setExpiry(payload) {
		return Repository.putWithAuth(`${resource}/expiry`, payload);
	},
	updateBillingConfig(id, payload) {
		return Repository.putWithAuth(`${resource}/${id}/billing-config`, payload);
	},
	details() {
		return Repository.getWithAuth(`${resource}/find/details`);
	},
	getReportExcel(payload, headers) {
		return Repository.postWithAuth(`${resource}/stats/excel`, payload, headers);
	},
	names() {
		return Repository.getWithAuth(`${resource}/names`);
	},
	getTotalUsers() {
		return Repository.getWithAuth(`${resource}/2fa/users`);
	},
	enableMfaMandatory(payload) {
		return Repository.putWithAuth(`${resource}/mfa/mandatory/enable`, payload);
	},
	disableMfaMandatory(payload) {
		return Repository.putWithAuth(`${resource}/mfa/mandatory/disable`, payload);
	},
	transferPrimaryOwner(payload) {
		return Repository.putWithAuth(`${resource}/primary-owner`, payload);
	},
};
